import { getGamesBySeason, fetchGamesBySeason } from '@/utils/api/games';

export default {
  namespaced: true,
  state: {
    seasonGames: [],
    lastSeasonForSeasonGames: 0,
  },
  getters: {
    seasonGames: state => state.seasonGames,
    seasonGamesPlayed: state => state.seasonGames.filter(game => game.game_status === 1),
    gamesPlayed(state, getters, rootState, rootGetters) {
      const PLAYING_AS = rootGetters['filterGeneral/getPlayingAs'];
      const RESULTS = rootGetters['filterGeneral/getResults'];
      return (
        getters.seasonGamesPlayed
          .filter(() => PLAYING_AS === null || PLAYING_AS === 1)
          .filter(game => {
            let result = 1;
            if (game.score[0] < game.score[1]) result = 2;
            else if (game.score[0] === game.score[1]) result = 3;
            return RESULTS.includes(result);
          }).length +
        getters.seasonGamesPlayed
          .filter(() => PLAYING_AS === null || PLAYING_AS === 2)
          .filter(game => {
            let result = 1;
            if (game.score[0] > game.score[1]) result = 2;
            else if (game.score[0] === game.score[1]) result = 3;
            return RESULTS.includes(result);
          }).length
      );
    },
  },
  mutations: {
    updateSeasonGames(state, seasonGames) {
      state.seasonGames = seasonGames;
    },
    updateLastSeasonForSeasonGames(state, seasonId) {
      state.lastSeasonForSeasonGames = seasonId;
    },
  },
  actions: {
    async getSeasonGames({ state, commit, rootGetters }, returnData = false) {
      try {
        const seasonId = rootGetters['filterGeneral/getSeasonId'];
        if (state.lastSeasonForSeasonGames === seasonId) {
          return undefined;
        }
        commit('updateLastSeasonForSeasonGames', seasonId);
        const seasonGames = await getGamesBySeason({ seasonId });
        if (returnData) {
          return seasonGames;
        }
        commit('updateSeasonGames', seasonGames);
      } catch (e) {
        throw new Error(e);
      }
    },
    fetchGamesBySeason(_, seasonId = 0) {
      return fetchGamesBySeason({ seasonId });
    },
  },
};
